import React from 'react';
import { useDispatch } from 'react-redux';
import { Grid, Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import Button from '@mui/material/Button';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Chip from '@mui/material/Chip';
import EditIcon from '@mui/icons-material/Edit';
import CheckIcon from '@mui/icons-material/Check';
import TextInputDialog from '../common/textinputdialog';
import DeleteConfirmDialog from '../common/deleteconfirmdialog';
import { newParameter, updateParameter, deleteParameter } from '../modules/parameterdata';
import { useTranslation } from 'react-i18next';
import { filter } from 'lodash';

const styles = {
    chip: { m: '0.5em' },
};

export const ParameterGroupView = (props) => {
    const dispatch = useDispatch();
    const [edit, setEdit] = React.useState(false);
    const [inputOpen, setInputOpen] = React.useState(false);
    const [paramToEdit, setParamToEdit] = React.useState(null);
    const [deleteConfirmOpen, setDeleteConfirmOpen] = React.useState(false);
    const [paramToDelete, setParamToDelete] = React.useState(null);
    //filteröidään custom parametrit id = 1
    const parameters = filter(props.parameters, (p) => p.id !== 1);
    const category = props.category;
    const { t } = useTranslation();

    const toggleEdit = () => {
        setEdit(!edit);
    };

    const addParameter = () => {
        setParamToEdit(null);
        setInputOpen(true);
    };

    const saveParam = async (text) => {
        setInputOpen(false);
        if (paramToEdit) {
            const toSave = paramToEdit;
            toSave.value = text;
            await updateParameter(toSave)(dispatch);
            setParamToEdit(null);
        } else {
            await newParameter(category, text)(dispatch);
        }
    };

    const editText = (id) => {
        setParamToEdit(parameters.find((p) => p.id === id));
        setInputOpen(true);
    };

    const handleDeleteClick = (param) => {
        setParamToDelete(param);
        setDeleteConfirmOpen(true);
    };

    const handleDeleteCancel = () => {
        setDeleteConfirmOpen(false);
        setParamToDelete(null);
    };

    const handleDeleteConfirm = async () => {
        if (paramToDelete) {
            await deleteParameter(paramToDelete)(dispatch);
        }
        setDeleteConfirmOpen(false);
        setParamToDelete(null);
    };

    return (
        <Grid item xs={12}>
            <Accordion>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Grid container justifyContent="space-between">
                        <Grid item xs={12}>
                            {parameters.length > 0 && <span>{parameters[0].categoryText}</span>}
                        </Grid>
                    </Grid>
                </AccordionSummary>
                <AccordionDetails>
                    <Grid container>
                        <Grid item container>
                            {parameters.map((v) => (
                                <Grid item key={v.id}>
                                    {edit && (
                                        <Chip
                                            sx={styles.chip}
                                            icon={<EditIcon />}
                                            clickable={true}
                                            label={v.value}
                                            onClick={() => editText(v.id)}
                                            onDelete={() => handleDeleteClick(v)}
                                            deleteIcon={<DeleteIcon />}
                                        />
                                    )}
                                    {!edit && <Chip sx={styles.chip} label={v.value} />}
                                </Grid>
                            ))}
                        </Grid>
                        <Grid item xs={12}>
                            <br />
                            {!edit && (
                                <Button
                                    startIcon={<EditIcon />}
                                    variant="contained"
                                    color="primary"
                                    name="btn-open-edit"
                                    onClick={toggleEdit}>
                                    {t('buttons.edit')}
                                </Button>
                            )}
                            {edit && (
                                <Grid item xs={12}>
                                    <Button
                                        startIcon={<AddIcon />}
                                        variant="contained"
                                        color="primary"
                                        name="btn-add"
                                        onClick={addParameter}>
                                        {t('buttons.add')}
                                    </Button>
                                    &nbsp;&nbsp;
                                    <Button
                                        startIcon={<CheckIcon />}
                                        variant="contained"
                                        color="primary"
                                        name="btn-close-edit"
                                        onClick={toggleEdit}>
                                        {t('buttons.close')}
                                    </Button>
                                </Grid>
                            )}
                        </Grid>
                    </Grid>
                </AccordionDetails>
            </Accordion>
            <TextInputDialog
                textFieldLabel={t('general.name')}
                open={inputOpen}
                confirm={saveParam}
                cancel={() => setInputOpen(false)}
                text={paramToEdit ? paramToEdit.value : ''}
            />
            <DeleteConfirmDialog
                open={deleteConfirmOpen}
                itemToDelete={paramToDelete ? paramToDelete.value : ''}
                confirmDelete={handleDeleteConfirm}
                cancel={handleDeleteCancel}
            />
        </Grid>
    );
};
